import TableCellText from "ds/components/Table/Row/CellText";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { pluralizeNext } from "shared/Pluralize";

import { SpaceDetailsAccessGrantedViaEntity } from "./types";

const SpaceDetailsAccessGrantedViaSummaryCell = ({
  item,
  ...cellProps
}: TableSimpleCellProps<SpaceDetailsAccessGrantedViaEntity>) => {
  const sourceCount = new Set(
    item.roleBindings.map((binding) => `${binding.grantedVia.kind}:${binding.grantedVia.id}`)
  ).size;
  const label = pluralizeNext(sourceCount, "source");

  return (
    <TableSimpleCell {...cellProps}>
      <TableCellText>{label}</TableCellText>
    </TableSimpleCell>
  );
};

export default SpaceDetailsAccessGrantedViaSummaryCell;
